import { StyleSheet, TouchableOpacity, View } from 'react-native'
import styled from 'styled-components'
import { media } from '../../../style/media'

const Container = styled(TouchableOpacity).attrs({ activeOpacity: 1 })`
  padding-right: ${(props) => props.theme.spacing.sm}px;
  padding-bottom: ${(props) => props.theme.spacing.sm}px;
  margin: 0 ${(props) => (props.spaced ? props.theme.spacing.smedium : 0)}px
    ${(props) => props.theme.spacing.smedium}px 0;
  flex-shrink: 0;
  ${media.sm`
    min-width: ${(props) => props.minWidth}px;
  `};
`

const Background = styled(View)`
  background-color: ${(props) => props.theme.colors[props.selected ? 'primary' : 'grayLighte']};
  margin-top: ${(props) => props.theme.spacing.sm}px;
  margin-left: ${(props) => props.theme.spacing.sm}px;
`

const Foreground = styled(View)`
  background-color: ${(props) => props.theme.colors.foreground};
  padding: ${(props) => props.theme.spacing.xs}px ${(props) => props.theme.spacing.smedium}px;
  align-items: center;
  ${media.sm`
    flex-grow: 1;
  `};
`

export const SemiBorderedBlock = ({
  selected,
  onPress,
  spaced = true,
  minWidth,
  style,
  children,
}) => (
  <Container as={!onPress ? View : undefined} onPress={onPress} spaced={spaced} minWidth={minWidth}>
    <Background selected={selected} style={StyleSheet.absoluteFill} />
    <Foreground style={style}>{children}</Foreground>
  </Container>
)
